import Circle from "../../../../../../src/entities/Circle";
import DrawCircleAnim from "../../../../../../src/animation/Intro/DrawCirleAnimation";
import { Coord } from "../../../../../../src/types/Interface";
import DrawLineAnim from "../../../../../../src/animation/Intro/DrawLineAnimation";
import Line from "../../../../../../src/entities/Line";
import DrawAngleAnim from "../../../../../../src/animation/Intro/DrawAngleAnim";
import PointManager from "../../PointManager/PointManager";
import MovePointAnimation from "../../../../../../src/animation/Intro/MovePointAnim";


export function drawCircleAnim(circle: Circle, targetRadian: number, radianIndex: number, isClockwise: boolean, coord: Coord): Promise<void> {
  return new Promise((resolve) => new DrawCircleAnim(circle, targetRadian, radianIndex, isClockwise, coord, () => resolve()));
}

export function drawLineAnim(line: Line, from: Coord, to: Coord): Promise<void> {
  line.visible = true;
  return new Promise((resolve) => new DrawLineAnim(line, from, to, resolve));
}

export function drawAngleAnim(angle, value: string): Promise<void> {
  return new Promise((resolve) => {
    angle.visible = true;
    angle.scale.set(0.3);
    new DrawAngleAnim(angle, () => {
      angle.AngleValue.setValue(value);
      angle.AngleValue.visible = true;
      resolve();
    });
  });
}

export function moveAllPointAnim(PointManager: PointManager, tRadians: number[]): Promise<void> {
  const redPoints = PointManager.getRedPoints();
  const sRadians = PointManager.getRadians();
  return new Promise((resolve) => {
    redPoints.forEach((redPoint, rI) => {
      return movePointAnim(sRadians[rI], tRadians[rI], (radian) => PointManager.setRadian([{ pTag: redPoint.tag, radian }]), () => resolve())
    })
  })
}


export function movePointAnim(sRadian: number, tRadian: number, callback: (radian: number) => void, onComp = () => { }): Promise<void> {
  return new Promise((resolve) => new MovePointAnimation(sRadian, tRadian, (radian) => callback(radian), () => { onComp(); resolve() }))
}
